var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from 'redux';
import AuthenticationReducer from './authentication/reducer';
import PublisherReducer from './publisher/reducer';
import HeaderReducer from './header/reducer';
import WidgetReducer from './widget/reducer';
import AlertReducer from './alert/reducer';
import GamReducer from './gam/reducer';
import NotificationGlobalReducer from './notification/reducer';
import ReportReducer from './report/reducer';
import AnnouncementReducer from './announcement/reducer';
// Combine all reducers into one root reducer
export default combineReducers(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, AuthenticationReducer), PublisherReducer), HeaderReducer), WidgetReducer), AlertReducer), GamReducer), NotificationGlobalReducer), ReportReducer), AnnouncementReducer));
